module.exports = __webpack_public_path__ + "static/media/manufacturing-macrovector-02-c 9.c6072dbc.png";